export default "__VITE_ASSET__21256080__"